import actionTypes from 'SRC/modules/redux/actionTypes'

export const resetState = () => ({
  type: actionTypes.RESET_EDIT_AD_STATE
})
